import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { database } from '../../firebase';
import { ref, onValue, update, remove } from 'firebase/database';
import SocialShareButton from './shareButton';
import Swal from 'sweetalert2';
import Style from '../assets/css/articleDetail.module.css';

const formatContent = (content) => {
    return content.split('\n').map((line, index) => (
        <span key={index}>
            {line}
            <br />
        </span>
    ));
};

const allowedUsers = [
    'zevach98zen@gmail.com',
    'thomync9876@gmail.com',
    'michellesuhey.palacios@gmail.com',
    'e9512351958@gmail.com',
    'xemaiagl@gmail.com',
    'alebarraber@gmail.com',
    'mixtecnautas@gmail.com'
];

const ArticleDetail = ({ user }) => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [article, setArticle] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [editedArticle, setEditedArticle] = useState({
        images: [],
        captions: []
    });

    useEffect(() => {
        const articleRef = ref(database, `posts/${id}`);
        onValue(articleRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                setArticle({
                    id,
                    images: data.images || [],
                    captions: data.captions || [],
                    ...data,
                });
                setEditedArticle({
                    id,
                    images: data.images || [],
                    captions: data.captions || [],
                    ...data,
                });
            } else {
                setArticle(null);
            }
        });
    }, [id]);

    const goBack = () => {
        navigate(-1);
    };

    const handleEditToggle = () => {
        setIsEditing(!isEditing);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedArticle({ ...editedArticle, [name]: value });
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const newImages = [...editedArticle.images];

        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                newImages.push(reader.result);
                setEditedArticle({ ...editedArticle, images: newImages });
            };
            reader.readAsDataURL(file);
        });
    };

    const handleImageDelete = (index) => {
        const newImages = editedArticle.images.filter((_, i) => i !== index);
        const newCaptions = editedArticle.captions.filter((_, i) => i !== index);
        setEditedArticle({ ...editedArticle, images: newImages, captions: newCaptions });
    };

    const handleSave = () => {
        const articleRef = ref(database, `posts/${id}`);

        const validCaptions = editedArticle.captions.map(caption => caption || "");

        const updatedArticle = {
            ...editedArticle,
            captions: validCaptions,
        };

        update(articleRef, updatedArticle)
            .then(() => {
                setIsEditing(false);
                alert("Artículo actualizado con éxito");
            })
            .catch((error) => {
                console.error("Error al actualizar el artículo:", error);
            });
    };

    const handleDeletePost = () => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "No podrás deshacer esta acción.",
            icon: "warning",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            confirmButtonColor: "#3085d6",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Sí, eliminarlo"
        }).then((result) => {
            if (result.isConfirmed) {
                const articleRef = ref(database, `posts/${id}`);
                remove(articleRef)
                    .then(() => {
                        Swal.fire({
                            title: "¡Eliminado!",
                            text: "El artículo ha sido eliminado con éxito.",
                            icon: "success"
                        }).then(() => {
                            navigate(-1);
                        });
                    })
                    .catch((error) => {
                        console.error("Error al eliminar el artículo:", error);
                        Swal.fire({
                            title: "Error",
                            text: "Hubo un problema al eliminar el artículo.",
                            icon: "error"
                        });
                    });
            }
        });
    };

    if (!article) {
        return <div>Artículo no encontrado</div>;
    }

    return (
        <>
            <div className={Style.articleContainer}>
                <div className={Style.buttonsPost}>
                    <button className={Style.goBackButton} onClick={goBack}>Regresar</button>
                    <SocialShareButton url={window.location.href} title={article.title} />
                </div>
                {isEditing ? (
                    <>
                        <input
                            type="text"
                            name="title"
                            value={editedArticle.title}
                            onChange={handleChange}
                            className={Style.articleTitleInput}
                        />
                        <input
                            type="date"
                            name="date"
                            value={new Date(editedArticle.date).toISOString().substring(0, 10)}
                            onChange={handleChange}
                            className={Style.articleDateInput}
                        />
                        <textarea
                            name="content"
                            value={editedArticle.content}
                            onChange={handleChange}
                            className={Style.articleContentInput}
                        />
                        <input
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            className={Style.imageInput}
                        />
                        {editedArticle.images.map((image, index) => (
                            <div key={index} className={Style.imageWrapper}>
                                <img
                                    src={image}
                                    alt={`Imagen ${index + 1}`}
                                    className={Style.articleImage}
                                />
                                <input
                                    type="text"
                                    placeholder="Pie de imagen"
                                    value={editedArticle.captions[index] || ''}
                                    onChange={(e) => {
                                        const newCaptions = [...(editedArticle.captions || [])];
                                        newCaptions[index] = e.target.value;
                                        setEditedArticle({ ...editedArticle, captions: newCaptions });
                                    }}
                                    className={Style.imageCaptionInput}
                                />
                                <button
                                    className={Style.deleteButton}
                                    onClick={() => handleImageDelete(index)}
                                >
                                    Eliminar
                                </button>
                            </div>
                        ))}
                        <button className={Style.saveButton} onClick={handleSave}>Guardar Cambios</button>
                    </>
                ) : (
                    <>
                        <h1 className={Style.articleTitle}>{article.title}</h1>
                        <p className={Style.articleDate}>{new Date(article.date).toLocaleDateString()}</p>
                        <p className={Style.articleAuthor}>Por: {article.author}</p>
                        {allowedUsers.includes(user?.email) && (
                            <div className={Style.buttonsPost}>
                                <button className={Style.deletePostButton} onClick={handleDeletePost}>
                                    Eliminar Artículo
                                </button>
                                <button className={Style.editButton} onClick={handleEditToggle}>
                                    Editar Artículo
                                </button>
                            </div>
                        )}
                        <div className={Style.articleContent}>
                            {article.content && article.content.includes("<") ? (
                                <div dangerouslySetInnerHTML={{ __html: article.content }} />
                            ) : (
                                <div>
                                    {formatContent(article.content)}
                                </div>
                            )}
                            {article.images && Array.isArray(article.images) && article.images.length > 0 ? (
                                <div className={Style.imageContainer}>
                                    {article.images.map((image, index) => (
                                        <div key={index} className={Style.imageWrapper}>
                                            <img
                                                src={image}
                                                alt={`Imagen ${index + 1} de ${article.title}`}
                                                className={Style.articleImage}
                                                onError={(e) => { e.target.style.display = 'none'; }}
                                            />
                                            {Array.isArray(article.captions) && article.captions[index] && (
                                                <p className={Style.imageCaption}>
                                                    {article.captions[index]}
                                                </p>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default ArticleDetail;
